import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'profile-card',
    templateUrl: './profile-card.component.html',
    styleUrls: ['profile-card.component.scss'],
    imports: [
        CommonModule
    ],
})
export class ProfileCardComponent {
    @Input() title: string = '';
}
